import { render, staticRenderFns } from "./dettaglioOrdine.html?vue&type=template&id=022a2487&scoped=true&"
import script from "./DettaglioOrdine.vue?vue&type=script&lang=js&"
export * from "./DettaglioOrdine.vue?vue&type=script&lang=js&"
import style0 from "./DettaglioOrdine.vue?vue&type=style&index=0&id=022a2487&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022a2487",
  null
  
)

export default component.exports